import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent {
  isMenuOpen = false;
  isToggling = false;
  languageMenuVisible = false;
  @ViewChild('languageMenu', { static: false }) languageMenuRef!: ElementRef;

  //language
  public lang: any;
  public defaultLanguage: string = environment.defaultLanguage;
  public systemLanguages: any[] = environment.systemLanguages;

  public flag: string = ''

  searchForm: FormGroup = new FormGroup({
    text: new FormControl('')
  });

  constructor(
      private router: Router,
      private translate: TranslateService
    ) {
    this.lang = localStorage.getItem('language') != null ? localStorage.getItem('language') : this.defaultLanguage;
    let language = this.systemLanguages.find((lang) => lang.code === this.lang);

    if(language == undefined){
      language = this.systemLanguages.find((lang) => lang.code === this.defaultLanguage);
      localStorage.removeItem('language');
      localStorage.setItem('language', this.defaultLanguage);
    }

    this.flag = language.flag;
  }

  toggleLanguageMenu(): void {
    this.languageMenuVisible = !this.languageMenuVisible;
  }

  toggleMenu(): void {
    if (this.isToggling) return;

    this.isToggling = true;
    this.isMenuOpen = !this.isMenuOpen;

    setTimeout(() => {
      this.isToggling = false;
    }, 300);
  }

  switchLanguage(lang: string): void {
    this.defaultLanguage = lang;
    this.languageMenuVisible = false;
    localStorage.setItem('language', lang);
    location.reload();
  }

  search(){
    let text = this.searchForm.get('text')?.value;
    if(text != undefined){
      this.router.navigate(['/resultados-pesquisa'], { queryParams: { search: text } });
    }
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    const targetElement = event.target as HTMLElement;
    if (this.languageMenuVisible && this.languageMenuRef && !this.languageMenuRef.nativeElement.contains(targetElement)) {
      this.languageMenuVisible = false;
    }
  }
}
